import { useCallback, useEffect, useState } from 'react';
import { fetchMeters } from '../services/meter.api';

export function useMeters() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const json = await fetchMeters();
      setData(Array.isArray(json) ? json : []);
    } catch {
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { data, loading, refresh: load };
}